var _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNarrowCandyDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 10,
    viewBox: "0 0 1440 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "candy_narrow__mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 1440,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000976562H1440L1437.23 9.99902H0V-0.000976562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#candy_narrow__mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000976562H1440V9.99902H0V-0.000976562Z",
    fill: "url(#candy_narrow__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269 -0.000976562H1324.3C1324.3 -0.000976562 1328.35 4.0464 1331.61 5.99902C1334.87 7.95164 1341 9.99902 1341 9.99902H1285.7C1285.7 9.99902 1279.56 7.95164 1276.3 5.99902C1273.04 4.0464 1269 -0.000976562 1269 -0.000976562Z",
    fill: "url(#candy_narrow__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 -0.000976562H1207.3C1207.3 -0.000976562 1211.35 4.0464 1214.61 5.99902C1217.87 7.95164 1224 9.99902 1224 9.99902H1168.7C1168.7 9.99902 1162.56 7.95164 1159.3 5.99902C1156.04 4.0464 1152 -0.000976562 1152 -0.000976562Z",
    fill: "url(#candy_narrow__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 -0.000976562H1090.3C1090.3 -0.000976562 1094.35 4.0464 1097.61 5.99902C1100.87 7.95164 1107 9.99902 1107 9.99902H1051.7C1051.7 9.99902 1045.56 7.95164 1042.3 5.99902C1039.04 4.0464 1035 -0.000976562 1035 -0.000976562Z",
    fill: "url(#candy_narrow__paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 -0.000976562H973.304C973.304 -0.000976562 977.349 4.0464 980.609 5.99902C983.869 7.95164 990 9.99902 990 9.99902H934.696C934.696 9.99902 928.564 7.95164 925.304 5.99902C922.044 4.0464 918 -0.000976562 918 -0.000976562Z",
    fill: "url(#candy_narrow__paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 -0.000976562H856.304C856.304 -0.000976562 860.349 4.0464 863.609 5.99902C866.869 7.95164 873 9.99902 873 9.99902H817.696C817.696 9.99902 811.564 7.95164 808.304 5.99902C805.044 4.0464 801 -0.000976562 801 -0.000976562Z",
    fill: "url(#candy_narrow__paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 -0.000976562H739.304C739.304 -0.000976562 743.349 4.0464 746.609 5.99902C749.869 7.95164 756 9.99902 756 9.99902H700.696C700.696 9.99902 694.564 7.95164 691.304 5.99902C688.044 4.0464 684 -0.000976562 684 -0.000976562Z",
    fill: "url(#candy_narrow__paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567 -0.000976562H622.304C622.304 -0.000976562 626.349 4.0464 629.609 5.99902C632.869 7.95164 639 9.99902 639 9.99902H583.696C583.696 9.99902 577.564 7.95164 574.304 5.99902C571.044 4.0464 567 -0.000976562 567 -0.000976562Z",
    fill: "url(#candy_narrow__paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 -0.000976562H505.304C505.304 -0.000976562 509.349 4.0464 512.609 5.99902C515.869 7.95164 522 9.99902 522 9.99902H466.696C466.696 9.99902 460.564 7.95164 457.304 5.99902C454.044 4.0464 450 -0.000976562 450 -0.000976562Z",
    fill: "url(#candy_narrow__paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 -0.000976562H388.304C388.304 -0.000976562 392.349 4.0464 395.609 5.99902C398.869 7.95164 405 9.99902 405 9.99902H349.696C349.696 9.99902 343.564 7.95164 340.304 5.99902C337.044 4.0464 333 -0.000976562 333 -0.000976562Z",
    fill: "url(#candy_narrow__paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 -0.000976562H271.304C271.304 -0.000976562 275.349 4.0464 278.609 5.99902C281.869 7.95164 288 9.99902 288 9.99902H232.696C232.696 9.99902 226.564 7.95164 223.304 5.99902C220.044 4.0464 216 -0.000976562 216 -0.000976562Z",
    fill: "url(#candy_narrow__paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 -0.000976562H154.304C154.304 -0.000976562 158.349 4.0464 161.609 5.99902C164.869 7.95164 171 9.99902 171 9.99902H115.696C115.696 9.99902 109.564 7.95164 106.304 5.99902C103.044 4.0464 99 -0.000976562 99 -0.000976562Z",
    fill: "url(#candy_narrow__paint11_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint0_linear",
    x1: 564,
    y1: -0.000976562,
    x2: 564,
    y2: 9.99902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint1_linear",
    x1: 1317.65,
    y1: -32.1467,
    x2: 1317.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint2_linear",
    x1: 1200.65,
    y1: -32.1467,
    x2: 1200.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint3_linear",
    x1: 1083.65,
    y1: -32.1467,
    x2: 1083.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint4_linear",
    x1: 966.648,
    y1: -32.1467,
    x2: 966.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint5_linear",
    x1: 849.648,
    y1: -32.1467,
    x2: 849.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint6_linear",
    x1: 732.648,
    y1: -32.1467,
    x2: 732.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint7_linear",
    x1: 615.648,
    y1: -32.1467,
    x2: 615.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint8_linear",
    x1: 498.648,
    y1: -32.1467,
    x2: 498.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint9_linear",
    x1: 381.648,
    y1: -32.1467,
    x2: 381.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint10_linear",
    x1: 264.648,
    y1: -32.1467,
    x2: 264.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "candy_narrow__paint11_linear",
    x1: 147.648,
    y1: -32.1467,
    x2: 147.66,
    y2: 9.96273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7689,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#FF5A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    stopColor: "#FF613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8663,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9259,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#D60000"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrowCandyDivider);
export default __webpack_public_path__ + "static/media/narrow-candy-divider.c859ae4a.svg";
export { ForwardRef as ReactComponent };